import { render } from "./BaseTextMessage.vue?vue&type=template&id=b1bec726&scoped=true"
import script from "./BaseTextMessage.vue?vue&type=script&lang=js"
export * from "./BaseTextMessage.vue?vue&type=script&lang=js"

import "./BaseTextMessage.vue?vue&type=style&index=0&id=b1bec726&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1bec726"]])

export default __exports__